export const GENERIC_SUBMISSION_ERROR =
  'There was a problem submitting your request, please try again.';

export const TIME_SLOT_SELECTION_ERROR = 'This appointment time is no longer available.';

export const COMPLETE_DOCUMENT_UPLOAD_ERROR =
  'Your appointment is scheduled, but we had an unexpected error loading the next page.';
